var _defs, _circle, _circle2, _circle3, _circle4, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopicLeyendas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E1B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#312E81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "moonGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDE047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#CA8A04"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "url(#bgGrad)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22,
    r: 0.8,
    fill: "#FFFFFF",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 18,
    r: 1.2,
    fill: "#FFFFFF",
    opacity: 0.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 36,
    r: 0.8,
    fill: "#FFFFFF",
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 48,15 L 48,21 M 45,18 L 51,18",
    stroke: "#FFFFFF",
    strokeWidth: 0.5,
    opacity: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24, 18)",
    filter: "drop-shadow(0px 0px 4px rgba(253, 224, 71, 0.4))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 12,0 16,10 16,20 C 16,30 10,34 0,34 C 8,34 11,26 11,17 C 11,8 6,0 0,0 Z",
    fill: "url(#moonGrad)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18, 32)",
    filter: "drop-shadow(0px 3px 2px rgba(15, 23, 42, 0.5))"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -8,18 L 8,6 L 22,18 Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2,12 L 20,4 L 32,18 Z",
    fill: "#1E293B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8,6               C 8,6 6,3 5,1               C 4,-1 2,-3 1,-3               C 0,-3 -1,-1 0,1               C 1,3 4,4 5,6               L 5,8               C 3,8 2,10 3,12               L 10,12               L 10,8 Z",
    fill: "#0F172A",
    transform: "translate(0, -2) scale(1.3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicLeyendas);
export default __webpack_public_path__ + "static/media/topic_leyendas.0032862a72e06b9b778a280c06978fe8.svg";
export { ForwardRef as ReactComponent };